import { findTileByID } from "../utils/findTileByID.js";
import { WIGGLE_FACTOR } from "../constants";
import { compareTiles } from "../utils/compareTiles.js";
import { QTile } from "./QTile.js";
import { compareNumbers } from "../utils/compareNumbers.js";
import { onlyUnique } from "../utils/onlyUnique.js";
import { compareBoxes_Y } from "../utils/compareBoxes_Y.js";
import { compareBoxes_X } from "../utils/compareBoxes_X.js";

export class QTileArray {
  constructor() {
    this.fTileArray = null;
    this.fFrontier = null;
    this.fMaxID = 0;
    this.fBoxMargin = 10;
  }

  AddTile(tile) {
    if (!this.fTileArray) {
      this.fTileArray = [];
    }

    tile.SetID(this.fMaxID++);
    tile.SetParentArray(this);
    this.fTileArray.push(tile);
  }

  RemoveTile(tile) {
    if (!this.fTileArray || this.fTileArray.length === 0) {
      return;
    }

    // need to update neighbors connections.
    var neighbor = tile.GetNeighbor("left");
    if (neighbor) {
      neighbor.RemoveConnection("right");
    }

    neighbor = tile.GetNeighbor("right");
    if (neighbor) {
      neighbor.RemoveConnection("left");
    }

    neighbor = tile.GetNeighbor("up");
    if (neighbor) {
      neighbor.RemoveConnection("down");
    }

    neighbor = tile.GetNeighbor("down");
    if (neighbor) {
      neighbor.RemoveConnection("up");
    }

    this.fRemovingTileID = tile.fID;
    var foundIndex = this.fTileArray.findIndex(findTileByID, this);
    if (foundIndex > -1) {
      this.fTileArray.splice(foundIndex, 1);
    }
  }

  RemoveTileByIndex(index) {
    if (!this.fTileArray || index >= this.fTileArray.length || index < 0) {
      return;
    }

    var tile = this.fTileArray[index];

    // need to update neighbors connections.
    var neighbor = tile.GetNeighbor("left");
    if (neighbor) {
      neighbor.RemoveConnection("right");
    }

    neighbor = tile.GetNeighbor("right");
    if (neighbor) {
      neighbor.RemoveConnection("left");
    }

    neighbor = tile.GetNeighbor("up");
    if (neighbor) {
      neighbor.RemoveConnection("down");
    }

    neighbor = tile.GetNeighbor("down");
    if (neighbor) {
      neighbor.RemoveConnection("up");
    }

    this.fTileArray.splice(index, 1);
  }

  RemoveHorizontalConnections(tile) {
    var rightNeighbor = tile.GetNeighbor("right");
    if (rightNeighbor) {
      tile.RemoveConnection("right");
      rightNeighbor.RemoveConnection("left");
    }

    var leftNeighbor = tile.GetNeighbor("left");
    if (leftNeighbor) {
      tile.RemoveConnection("left");
      leftNeighbor.RemoveConnection("right");
    }
  }

  RemoveVerticalConnections(tile) {
    var topNeighbor = tile.GetNeighbor("up");
    if (topNeighbor) {
      tile.RemoveConnection("up");
      topNeighbor.RemoveConnection("down");
    }

    var downNeighbor = tile.GetNeighbor("down");
    if (downNeighbor) {
      tile.RemoveConnection("down");
      downNeighbor.RemoveConnection("up");
    }
  }

  // returns an array of Tiles that have pt value going through them.
  // returns null if none found
  GetIntersectedTile(pt) {
    var resultTile = null;

    if (!this.fTileArray) {
      return resultTile;
    }

    var numTiles = this.fTileArray.length;
    for (var i = 0; i < numTiles; i++) {
      var Tile = this.fTileArray[i];
      if (pt.x >= Tile.left && pt.x <= Tile.right && pt.y >= Tile.top && pt.y <= Tile.bottom) {
        resultTile = Tile;
        break;
      }
    }

    return resultTile;
  }

  ResetStatuses() {
    if (!this.fTileArray) {
      return;
    }

    for (var i = 0; i < this.fTileArray.length; i++) {
      var tile = this.fTileArray[i];
      tile.fFlag = "";
      tile.fScore = Number.POSITIVE_INFINITY;
      tile.fBestNeighborType = "";
      tile.fBestNeighbor = null;
    }
  }

  FindClosestTile(pt) {
    var closestTile = null;
    var minDist = Number.POSITIVE_INFINITY;
    var dist = Number.POSITIVE_INFINITY;
    if (this.fTileArray) {
      switch (pt.side) {
        case "left":
          for (var i = 0; i < this.fTileArray.length; i++) {
            var tile = this.fTileArray[i];
            if (tile.fCenter.y === pt.y && pt.x - tile.fCenter.x === this.fBoxMargin) {
              dist = pt.x - tile.fCenter.x;
              if (dist < minDist) {
                minDist = dist;
                closestTile = tile;
              }
            }
          }
          break;

        case "right":
          for (i = 0; i < this.fTileArray.length; i++) {
            tile = this.fTileArray[i];
            if (tile.fCenter.y === pt.y && tile.fCenter.x - pt.x === this.fBoxMargin) {
              dist = tile.fCenter.x - pt.x;
              if (dist < minDist) {
                minDist = dist;
                closestTile = tile;
              }
            }
          }
          break;

        case "top":
          for (i = 0; i < this.fTileArray.length; i++) {
            tile = this.fTileArray[i];
            if (tile.fCenter.x === pt.x && pt.y - tile.fCenter.y === this.fBoxMargin) {
              dist = pt.y - tile.fCenter.y;
              if (dist < minDist) {
                minDist = dist;
                closestTile = tile;
              }
            }
          }
          break;

        case "bottom":
          for (i = 0; i < this.fTileArray.length; i++) {
            tile = this.fTileArray[i];
            if (tile.fCenter.x === pt.x && tile.fCenter.y - pt.y === this.fBoxMargin) {
              dist = tile.fCenter.y - pt.y;
              if (dist < minDist) {
                minDist = dist;
                closestTile = tile;
              }
            }
          }
          break;

        default: // this should not happen. But it's here for backward compatibility
          for (i = 0; i < this.fTileArray.length; i++) {
            tile = this.fTileArray[i];
            dist =
              (pt.x - tile.fCenter.x) * (pt.x - tile.fCenter.x) +
              (pt.y - tile.fCenter.y) * (pt.y - tile.fCenter.y);
            if (dist < minDist) {
              minDist = dist;
              closestTile = tile;
            }
          }

          break;
      }
    }

    return closestTile;
  }

  FindCorrespondingTile(pt) {
    var closestTile = null;
    if (this.fTileArray) {
      for (var i = 0; i < this.fTileArray.length; i++) {
        var tile = this.fTileArray[i];
        if (tile.fCenter.y === pt.y && pt.x === tile.fCenter.x) {
          closestTile = tile;
          break;
        }
      }
    }

    return closestTile;
  }

  MakeSparse(factor) {
    if (!this.fTileArray) {
      return;
    }

    for (var n = 0; n < factor; n++) {
      var numTiles = this.fTileArray.length;
      for (var i = numTiles - 1; i >= 0; i--) {
        var tile = this.fTileArray[i];
        if (tile.HasEightNeighbors()) {
          this.RemoveTileByIndex(i);
        }
      }
    }
  }

  FindClosestConnection(pt, tile, direction) {
    var tileCenter = tile.GetCenter();
    var dx = pt.x - tileCenter.x;
    var dy = pt.y - tileCenter.y;
    if (direction === "up") {
      if (dx > 0) {
        var neighbor = tile.GetNeighbor("right");
      }

      if (dx < 0) {
        neighbor = tile.GetNeighbor("left");
      }

      if (neighbor !== null) {
      }
    }
    if (Math.abs(dx) < Math.abs(dy)) {
    }
  }

  FindShortestPath(pt1, pt2) {
    if (!this.fFrontier) {
      this.fFrontier = [];
    }

    var path = [];

    // now, we traverse back to source from target
    var source = this.FindCorrespondingTile(pt1);
    var target = this.FindCorrespondingTile(pt2);

    if (source !== null && target !== null) {
      this.fFrontier.length = 0;
      source.fBestNeighbor = null;
      source.fBestNeighborType = "";
      source.fScore = 0;
      this.fFrontier.push(source);

      this.UpdateFrontier(target);

      var pt = { x: target.fCenter.x, y: target.fCenter.y };
      path.push(pt);
      var bestNeighbor = target.fBestNeighbor;
      var pathDirection = target.fBestNeighborType;
      while (bestNeighbor) {
        if (bestNeighbor.fBestNeighborType !== pathDirection) {
          pt = bestNeighbor.fCenter;
          path.push(pt);
          pathDirection = bestNeighbor.fBestNeighborType;
        }
        bestNeighbor = bestNeighbor.fBestNeighbor;
      }

      //path.push({x: pt1.x, y: pt1.y});
    }

    return path;
  }

  // Adds neighbors that are not done and not in frontier to the frontier list
  // Updates score of each elements of neighbors in frontier
  // Sort frontier list
  // make tile done
  UpdateFrontier(targetTile) {
    if (this.fFrontier.length === 0) {
      return;
    }

    var tile = this.fFrontier.shift();

    for (var i = 0; i < tile.fConnections.length; i++) {
      var connection = tile.fConnections[i];
      var neighbor = connection.fTargetTile;
      if (neighbor.fFlag === "") {
        neighbor.fFlag = "active";
        this.fFrontier.push(neighbor);
      }

      if (neighbor.fFlag === "active") {
        var newScore = tile.fScore + connection.fValue;

        // this is penalty for bending.
        newScore +=
          (WIGGLE_FACTOR * (tile.fBestNeighborType !== connection.fType)) / (connection.fValue + 1);
        if (newScore < neighbor.fScore) {
          neighbor.fScore = newScore;
          neighbor.fBestNeighbor = tile;
          neighbor.fBestNeighborType = connection.fType;
        }
      }
    }

    if (targetTile.fFlag !== "done") {
      this.fFrontier.sort(compareTiles);
      tile.fFlag = "done";
      this.UpdateFrontier(targetTile);
    }
  }

  LogFrontier() {
    if (!this.fFrontier) return;

    var msg = "Frontier: ";
    for (var i = 0; i < this.fFrontier.length; i++) {
      var tile = this.fFrontier[i];
      msg += "[" + tile.fID + ", " + tile.fScore + "] ";
    }

    console.log(msg);
  }

  BreakByBox(box) {
    var corners = [];
    corners.push({ x: box.left, y: box.top });
    corners.push({ x: box.left, y: box.bottom });
    corners.push({ x: box.right, y: box.top });
    corners.push({ x: box.right, y: box.bottom });

    for (var i = 0; i < corners.length; i++) {
      var pt = corners[i];
      var tile = this.GetIntersectedTile(pt);
      if (tile) {
        tile.SplitHorizontal(pt.x);
        tile.SplitVertical(pt.y);
      }
    }

    // now all intersection are divided. Remove internal tiles
    var numTiles = this.fTileArray.length;
    for (i = numTiles - 1; i >= 0; i--) {
      tile = this.fTileArray[i];
      if (
        tile.left >= box.left &&
        tile.right <= box.right &&
        tile.top >= box.top &&
        tile.bottom <= box.bottom
      ) {
        this.RemoveTileByIndex(i);
      }
    }

    // now need to split tiles that are still left and are crossed by box
  }

  GetConnectionLines() {
    var lines = [];

    for (var i = 0; i < this.fTileArray.length; i++) {
      var tile = this.fTileArray[i];
      var tileNeighbor = tile.GetNeighbor("right");
      if (tileNeighbor) {
        var line = {
          pt1: { x: tile.fCenter.x, y: tile.fCenter.y },
          pt2: { x: tileNeighbor.fCenter.x, y: tileNeighbor.fCenter.y }
        };
        lines.push(line);
      }

      tileNeighbor = tile.GetNeighbor("up");
      if (tileNeighbor) {
        line = {
          pt1: { x: tile.fCenter.x, y: tile.fCenter.y },
          pt2: { x: tileNeighbor.fCenter.x, y: tileNeighbor.fCenter.y }
        };
        lines.push(line);
      }
    }

    return lines;
  }

  LogTileArray() {
    if (!this.fTileArray || this.fTileArray.length === 0) {
      return;
    }

    console.log("Tile Array: ");
    this.fTileArray.forEach(tile => tile.LogTile(tile));
  }

  GetSegment(arr, value) {
    for (var i = 0; i < arr.length; i++) {
      if (value >= arr[i].start && value <= arr[i].end) {
        return arr[i];
      }
    }
  }

  ConstructByGrid(xPoints, yPoints) {
    if (!this.fTileArray) {
      this.fTileArray = [];
    }

    this.fTileArray.length = 0;

    var numX = xPoints.length;
    var numY = yPoints.length;

    var leftTile = null;
    var topTile = null;
    for (var i = 0; i < numX; i++) {
      var x = xPoints[i];
      for (var j = 0; j < numY; j++) {
        var y = yPoints[j];
        var tile = new QTile();
        var tileBox = {
          left: x - 1,
          right: x + 1,
          top: y - 1,
          bottom: y + 1
        };
        tile.InitTile(tileBox);
        if (j > 0) {
          topTile = this.fTileArray[this.fTileArray.length - 1];
          tile.Connect(topTile);
        }

        if (i > 0) {
          leftTile = this.fTileArray[this.fTileArray.length - numY];
          tile.Connect(leftTile);
        }

        this.AddTile(tile);
      }
    }
  }

  ConstructByBoxes(boxes, margin) {
    this.fBoxMargin = margin;
    var xPoints = [];
    var yPoints = [];
    for (var i = 0; i < boxes.length; i++) {
      var box = boxes[i];

      xPoints.push(box.left - this.fBoxMargin);
      xPoints.push(box.right + this.fBoxMargin);
      yPoints.push(box.top - this.fBoxMargin);
      yPoints.push(box.bottom + this.fBoxMargin);

      var numAnchors = box.anchors.length;

      for (var j = 0; j < numAnchors; j++) {
        var anchorPt = box.anchors[j];
        if (anchorPt.side === "left" || anchorPt.side === "right") {
          yPoints.push(anchorPt.y);
        }
        if (anchorPt.side === "top" || anchorPt.side === "bottom") {
          xPoints.push(anchorPt.x);
        }
      }
    }

    // first sort them and remove repeated items
    xPoints.sort(compareNumbers);
    yPoints.sort(compareNumbers);

    xPoints = xPoints.filter(onlyUnique);
    yPoints = yPoints.filter(onlyUnique);

    //xPoints = xPoints.filter(onlyNotClose);
    //yPoints = yPoints.filter(onlyNotClose);

    // Add an edge around to allow for margin
    //xPoints.unshift(xPoints[0] - margin);
    //xPoints.push(xPoints[xPoints.length - 1] + 15);
    //yPoints.push(yPoints[yPoints.length - 1] + 15);

    this.ConstructByGrid(xPoints, yPoints);

    //this.PruneGridPoints(boxes);
    this.PruneGridPoints2(boxes);

    // Add anchor points to the grid
    var anchorTiles = [];

    for (i = this.fTileArray.length - 1; i >= 0; i--) {
      var tile = this.fTileArray[i];
      var cx = tile.GetCenter().x;
      var cy = tile.GetCenter().y;
      var anchorPointNeighbor = false;
      for (j = 0; j < boxes.length; j++) {
        box = boxes[j];
        numAnchors = box.anchors.length;
        for (var k = 0; k < numAnchors; k++) {
          anchorPt = box.anchors[k];
          switch (anchorPt.side) {
            case "left":
              if (cy === anchorPt.y && anchorPt.x - cx === this.fBoxMargin) {
                anchorPointNeighbor = true;
                var newPt = anchorPt;
                var adjacentTile = tile;
              }
              break;

            case "right":
              if (cy === anchorPt.y && cx - anchorPt.x === this.fBoxMargin) {
                anchorPointNeighbor = true;
                newPt = anchorPt;
                adjacentTile = tile;
              }
              break;

            case "top":
              if (cx === anchorPt.x && anchorPt.y - cy === this.fBoxMargin) {
                anchorPointNeighbor = true;
                newPt = anchorPt;
                adjacentTile = tile;
              }
              break;

            case "bottom":
              if (cx === anchorPt.x && cy - anchorPt.y === this.fBoxMargin) {
                anchorPointNeighbor = true;
                newPt = anchorPt;
                adjacentTile = tile;
              }
              break;
          }
        }
      }

      if (anchorPointNeighbor) {
        var newTile = new QTile();
        var tileBox = {
          left: newPt.x - 1,
          right: newPt.x + 1,
          top: newPt.y - 1,
          bottom: newPt.y + 1
        };

        newTile.InitTile(tileBox);
        newTile.Connect(adjacentTile);
        anchorTiles.push(newTile);
      }
    }

    for (i = 0; i < anchorTiles.length; i++) {
      tile = anchorTiles[i];
      this.AddTile(tile);
    }
  }

  IsYAnchorPoint(box, side, y) {
    var numAnchors = box.anchors.length;
    for (var i = 0; i < numAnchors; i++) {
      if (box.anchors[i].side === side && y === box.anchors[i].y) {
        return true;
      }
    }

    return false;
  }

  IsXAnchorPoint(box, side, x) {
    var numAnchors = box.anchors.length;
    for (var i = 0; i < numAnchors; i++) {
      if (box.anchors[i].side === side && x === box.anchors[i].x) {
        return true;
      }
    }

    return false;
  }

  PruneGridPoints(boxes) {
    // remove tiles that happen to be inside any box
    for (var i = this.fTileArray.length - 1; i >= 0; i--) {
      var tile = this.fTileArray[i];
      var cx = tile.GetCenter().x;
      var cy = tile.GetCenter().y;
      var isInside = false;
      for (var j = 0; j < boxes.length; j++) {
        var box = boxes[j];
        if (
          cx > box.left - this.fBoxMargin &&
          cx < box.right + this.fBoxMargin &&
          cy > box.top - this.fBoxMargin &&
          cy < box.bottom + this.fBoxMargin
        ) {
          isInside = true;
          break;
        }
      }

      if (isInside) {
        this.RemoveTileByIndex(i);
      }
    }

    // remove connections whose right neighbor crosses a box
    for (i = this.fTileArray.length - 1; i >= 0; i--) {
      tile = this.fTileArray[i];
      cx = tile.GetCenter().x;
      cy = tile.GetCenter().y;
      var rightTile = tile.GetNeighbor("right");
      var isCrossing = false;
      if (rightTile) {
        var cx_r = rightTile.GetCenter().x;
        for (j = 0; j < boxes.length; j++) {
          box = boxes[j];
          if (
            cx <= box.left - this.fBoxMargin &&
            cx_r >= box.right + this.fBoxMargin &&
            cy > box.top - this.fBoxMargin &&
            cy < box.bottom + this.fBoxMargin
          ) {
            isCrossing = true;
            break;
          }
        }
      }

      if (isCrossing) {
        tile.RemoveConnection("right");
        rightTile.RemoveConnection("left");
      }
    }

    // remove connections whose bottom neighbor crosses a box
    for (i = this.fTileArray.length - 1; i >= 0; i--) {
      tile = this.fTileArray[i];
      cx = tile.GetCenter().x;
      cy = tile.GetCenter().y;
      var bottomTile = tile.GetNeighbor("down");
      isCrossing = false;
      if (bottomTile) {
        var cy_b = bottomTile.GetCenter().y;
        for (j = 0; j < boxes.length; j++) {
          box = boxes[j];
          if (
            cy <= box.top - this.fBoxMargin &&
            cy_b >= box.bottom + this.fBoxMargin &&
            cx > box.left - this.fBoxMargin &&
            cx < box.right + this.fBoxMargin
          ) {
            isCrossing = true;
            break;
          }
        }
      }

      if (isCrossing) {
        tile.RemoveConnection("down");
        bottomTile.RemoveConnection("up");
      }
    }
  }

  PruneGridPoints2(boxes) {
    // starting from top left of the grid, tag tiles for two purposes:
    // 1- find those that are in the box.
    // 2- find those that are between boxes but have no adjacent anchor points.
    // Group 1 need to be deleted altogether with connections obliterated
    // Group 2 need to be deleted with one dimension connection stay.

    var tile = this.fTileArray[0];
    var tile2 = tile.GetNeighbor("down");

    // going down
    while (tile2 !== null) {
      var y = tile2.GetCenter().y;

      var segments_x = this.GenerateSegments_X(boxes, y);
      if (segments_x.length !== 0) {
        var tileL = tile2;
        tileL.action = "keep";
        var sectionL = 0;
        var tileR = tileL.GetNeighbor("right");
        while (tileR !== null) {
          var segment = this.GetSegment(segments_x, tileR.GetCenter().x);
          if (segment.type === "remove_4") {
            tileR.action = "remove";
          } else if (segment.type === "remove_hor") {
            tileR.action = "remove_hor";
          } else if (segment.section !== sectionL) {
            tileR.action = "remove_left";
          }

          tileL = tileR;
          tileR = tileL.GetNeighbor("right");
          sectionL = segment.section;
        }
      }

      tile = tile2;
      tile2 = tile.GetNeighbor("down");
    }

    // going across
    tile = this.fTileArray[0];
    tile2 = tile.GetNeighbor("right");

    while (tile2 !== null) {
      var x = tile2.GetCenter().x;
      var segments_y = this.GenerateSegments_Y(boxes, x);
      if (segments_y.length !== 0) {
        var tileT = tile2;
        tileT.action = "keep";
        var sectionT = 0;
        var tileD = tileT.GetNeighbor("down");
        while (tileD !== null) {
          segment = this.GetSegment(segments_y, tileD.GetCenter().y);
          if (segment.type === "remove_4") {
            tileD.action = "remove";
          } else if (segment.type === "remove_ver") {
            if (tileD.action === "remove_hor") {
              tileD.action = "remove";
            } else {
              tileD.action = "remove_ver";
            }
          } else if (segment.section !== sectionT) {
            tileD.action = "remove_up";
          }

          tileT = tileD;
          tileD = tileT.GetNeighbor("down");
          sectionT = segment.section;
        }
      }

      tile = tile2;
      tile2 = tile.GetNeighbor("right");
    }

    for (var i = this.fTileArray.length - 1; i >= 0; i--) {
      tile = this.fTileArray[i];
      if (tile.action === "remove") {
        this.RemoveTileByIndex(i);
      }

      if (tile.action === "remove_hor") {
        this.RemoveHorizontalConnections(tile);
      }

      if (tile.action === "remove_ver") {
        this.RemoveVerticalConnections(tile);
      }

      if (tile.action === "remove_left") {
        tileL = tile.GetNeighbor("left");
        tile.RemoveConnection("left");
        tileL.RemoveConnection("right");
      }

      if (tile.action === "remove_up") {
        tileT = tile.GetNeighbor("up");
        tile.RemoveConnection("up");
        tileT.RemoveConnection("down");
      }
    }

    this.MergeStraightConnections();
  }

  MergeStraightConnections() {
    for (var i = this.fTileArray.length - 1; i >= 0; i--) {
      var tile = this.fTileArray[i];
      var tileR = tile.GetNeighbor("right");
      var tileL = tile.GetNeighbor("left");
      var tileT = tile.GetNeighbor("up");
      var tileD = tile.GetNeighbor("down");
      if (tileR !== null && tileL !== null && tileT === null && tileD === null) {
        tileR.Connect(tileL);
        this.fTileArray.splice(i, 1);
      } else if (tileR === null && tileL === null && tileT !== null && tileD !== null) {
        tileD.Connect(tileT);
        this.fTileArray.splice(i, 1);
      }
    }
  }

  GenerateSegments_X(boxes, y) {
    var boxesOfInterest = [];
    var segments = [];
    var y1 = y - this.fBoxMargin;
    var y2 = y + this.fBoxMargin;
    var bMargin = this.fBoxMargin - 1;
    var intersectingExists = false;
    for (var i = 0; i < boxes.length; i++) {
      var box = boxes[i];
      if (y >= box.top - bMargin && y <= box.bottom + bMargin) {
        box.type = "intersecting";
        boxesOfInterest.push(box);
        intersectingExists = true;
      } else if (box.top === y1 || box.top === y2 || box.bottom === y1 || box.bottom === y2) {
        box.type = "margin";
        boxesOfInterest.push(box);
      }
    }

    if (intersectingExists) {
      boxesOfInterest.sort(compareBoxes_X);

      var x1 = Number.NEGATIVE_INFINITY;
      var segmentType = "remove_hor";
      var segmentSection = 0;
      for (i = 0; i < boxesOfInterest.length; i++) {
        box = boxesOfInterest[i];
        if (box.type === "intersecting") {
          if (this.IsYAnchorPoint(box, "left", y)) {
            segmentType = "keep";
          }
          segments.push({
            start: x1,
            end: box.left - bMargin - 1,
            type: segmentType,
            section: segmentSection
          });
          segments.push({
            start: box.left - bMargin,
            end: box.right + bMargin,
            type: "remove_4",
            section: segmentSection + 1
          });
          x1 = box.right + bMargin + 1;
          segmentSection += 2;
          if (this.IsYAnchorPoint(box, "right", y)) {
            segmentType = "keep";
          } else {
            segmentType = "remove_hor";
          }
        }

        if (box.type === "margin") {
          segments.push({
            start: x1,
            end: box.right,
            type: "keep",
            section: segmentSection
          });
          x1 = box.right + 1;
          segmentType = "keep";
        }
      }

      segments.push({
        start: x1,
        end: Number.POSITIVE_INFINITY,
        type: segmentType,
        section: segmentSection
      });
    }

    return segments;
  }

  GenerateSegments_Y(boxes, x) {
    var boxesOfInterest = [];
    var segments = [];
    var x1 = x - this.fBoxMargin;
    var x2 = x + this.fBoxMargin;
    var bMargin = this.fBoxMargin - 1;

    var intersectingExists = false;
    for (var i = 0; i < boxes.length; i++) {
      var box = boxes[i];
      if (x >= box.left - bMargin && x <= box.right + bMargin) {
        box.type = "intersecting";
        boxesOfInterest.push(box);
        intersectingExists = true;
      } else if (box.left === x1 || box.left === x2 || box.right === x1 || box.right === x2) {
        box.type = "margin";
        boxesOfInterest.push(box);
      }
    }

    if (intersectingExists) {
      boxesOfInterest.sort(compareBoxes_Y);

      var y1 = Number.NEGATIVE_INFINITY;
      var segmentType = "remove_ver";
      var segmentSection = 0;
      for (i = 0; i < boxesOfInterest.length; i++) {
        box = boxesOfInterest[i];
        if (box.type === "intersecting") {
          if (this.IsXAnchorPoint(box, "top", x)) {
            segmentType = "keep";
          }
          segments.push({
            start: y1,
            end: box.top - bMargin - 1,
            type: segmentType,
            section: segmentSection
          });
          segments.push({
            start: box.top - bMargin,
            end: box.bottom + bMargin,
            type: "remove_4",
            section: segmentSection + 1
          });
          y1 = box.bottom + bMargin + 1;
          segmentSection += 2;

          if (this.IsXAnchorPoint(box, "bottom", x)) {
            segmentType = "keep";
          } else {
            segmentType = "remove_ver";
          }
        }

        if (box.type === "margin") {
          segments.push({
            start: y1,
            end: box.bottom,
            type: "keep",
            section: segmentSection
          });
          y1 = box.bottom + 1;
          segmentType = "keep";
        }
      }

      segments.push({
        start: y1,
        end: Number.POSITIVE_INFINITY,
        type: segmentType,
        section: segmentSection
      });
    }

    return segments;
  }
}
